import {saveEvent} from '../api';
import {parseCoordinates} from '../utils/search_coordinates';

const resetQuickCoordinateModal = () => {
    const modalEl = document.getElementById('quick-coordinate-modal');

    if (!modalEl) {
        return;
    }

    modalEl.querySelectorAll('input').forEach(input => {
        input.value = '';
        input.classList.remove('valid', 'invalid');
    });

    modalEl.querySelectorAll('select').forEach(select => {
        select.selectedIndex = 0;
        M.FormSelect.init(select);
    });

    M.updateTextFields();
};

/**
 * Controle pour saisir des coordonnées (EasyButton style)
 */
const quickCoordinateControl = L.Control.extend({
    options: {position: 'topleft'},

    onAdd: function (map) {
        const container = L.DomUtil.create('div', 'leaflet-bar leaflet-control');
        const btn = L.DomUtil.create('a', 'leaflet-control-custom fa-control', container);

        btn.innerHTML = '<i class="fa-solid fa-crosshairs"></i>';
        btn.title = 'Saisir des coordonnées';
        btn.href = '#';

        btn.onclick = (e) => {
            e.preventDefault();
            let modalEl = document.getElementById('quick-coordinate-modal');
            if (!modalEl) {
                const modalHtml = Handlebars.templates['coordinate-input-modal']({});
                document.body.insertAdjacentHTML('beforeend', modalHtml);
                modalEl = document.getElementById('quick-coordinate-modal');
                M.Modal.init(modalEl);
                M.FormSelect.init(modalEl.querySelectorAll('select'));

                // Ajouter la validation à la saisie
                modalEl.querySelectorAll('input.validate').forEach(input => {
                    input.addEventListener('input', () => {
                        if (input.checkValidity()) {
                            input.classList.remove('invalid');
                            input.classList.add('valid');
                        } else {
                            input.classList.remove('valid');
                            input.classList.add('invalid');
                        }
                    });
                });
            }

            const modal = M.Modal.getInstance(modalEl);

            modal.open();

            document.getElementById('btn-validate-coord').onclick = () => {
                let input = '';

                // Essayer DD
                const ddLat = document.getElementById('coord-dd-lat').value.replace(',', '.');
                const ddLng = document.getElementById('coord-dd-lng').value.replace(',', '.');
                if (ddLat && ddLng) {
                    input = `${ddLat} ${ddLng}`;
                } else {
                    // Essayer DM
                    const dmLatDeg = document.getElementById('coord-dm-lat-deg').value;
                    const dmLatMin = document.getElementById('coord-dm-lat-min').value.replace(',', '.');
                    const dmLngDeg = document.getElementById('coord-dm-lng-deg').value;
                    const dmLngMin = document.getElementById('coord-dm-lng-min').value.replace(',', '.');
                    if (dmLatDeg && dmLatMin && dmLngDeg && dmLngMin) {
                        const latHem = document.getElementById('coord-dm-lat-hem').value;
                        const lngHem = document.getElementById('coord-dm-lng-hem').value;
                        input = `${latHem} ${dmLatDeg}°${dmLatMin} ${lngHem} ${dmLngDeg}°${dmLngMin}`;
                    } else {
                        // Essayer DMS
                        const dmsLatDeg = document.getElementById('coord-dms-lat-deg').value;
                        const dmsLatMin = document.getElementById('coord-dms-lat-min').value;
                        const dmsLatSec = document.getElementById('coord-dms-lat-sec').value.replace(',', '.');
                        const dmsLngDeg = document.getElementById('coord-dms-lng-deg').value;
                        const dmsLngMin = document.getElementById('coord-dms-lng-min').value;
                        const dmsLngSec = document.getElementById('coord-dms-lng-sec').value.replace(',', '.');
                        if (dmsLatDeg && dmsLatMin && dmsLatSec && dmsLngDeg && dmsLngMin && dmsLngSec) {
                            const latHem = document.getElementById('coord-dms-lat-hem').value;
                            const lngHem = document.getElementById('coord-dms-lng-hem').value;
                            input = `${latHem} ${dmsLatDeg}°${dmsLatMin}'${dmsLatSec} ${lngHem} ${dmsLngDeg}°${dmsLngMin}'${dmsLngSec}`;
                        } else {
                            // Essayer UTM
                            const zone = document.getElementById('coord-utm-zone').value;
                            const easting = document.getElementById('coord-utm-easting').value;
                            const northing = document.getElementById('coord-utm-northing').value;
                            if (zone && easting && northing) {
                                input = `${zone} ${easting} ${northing}`;
                            }
                        }
                    }
                }

                if (input) {
                    const template = Handlebars.templates['coordinates-result'];
                    const isEventDetails = map.eventId !== null && map.eventId !== undefined;

                    parseCoordinates(input, map).then(latlng => {
                        if (latlng) {
                            const resultHtml = template({ lat: latlng.lat, lng: latlng.lng, isEventDetails: isEventDetails });
                            L.marker(latlng)
                                .addTo(map)
                                .bindPopup(resultHtml)
                                .openPopup();
                            map.setView(latlng, 16);

                            modal.close();
                        } else {
                            alert("Format non reconnu ou coordonnées invalides");
                        }
                    });
                } else {
                    alert("Veuillez remplir tous les champs");
                }
            };
        };

        return container;
    }
});

/**
 * Controle pour créer un événement

const createEventControl = L.Control.extend({
    options: {position: 'topleft'},

    onAdd: (map) => {
        const btn = L.DomUtil.create('a', 'leaflet-bar leaflet-control leaflet-control-custom fa-control');
        btn.innerHTML = '<span style="color: red; font-size: 24px"><i class="fa-solid fa-star-of-life"></i></span>';
        btn.title = 'Nouvel événement';

        btn.onclick = () => {
            resetQuickCoordinateModal();

            const eventName = '';
            saveEvent({
                "name": eventName,
                "description": eventName,
                "local_id": null
            }).then(event => {
                const url = new URL(window.location.href);
                url.search = new URLSearchParams({
                    event: event.id,
                    map: map.getCurrentMap(),
                    zoom: map.getZoom(),
                    lat: map.getCenter().lat,
                    lng: map.getCenter().lng
                }).toString();
                window.open(url.toString(), '_blank');
            });
        };

        return btn;
    }
});
*/

/**
 * Controle pour dessiner un marker sur un événement
 * avec une sélection du type de marker
 * @param {*} options
 * @returns
 */
const gendlocMakerControl = (options) => ({
    name: 'gendloc_marker',
    block: 'draw',
    title: 'Ajouter un point',
    className: 'control-icon leaflet-pm-icon-marker',
    toggle: true,
    onClick: (event) => {
        const existingSelector = document.getElementById('type-selector');

        if (existingSelector) {
            existingSelector.remove();
            return;
        }

        const container = event.target.parentElement.parentElement
            .getElementsByClassName('leaflet-pm-actions-container')[0];

        const selector = L.DomUtil.create('div', 'type-selector', container);
        selector.id = 'type-selector';

        const hasEventMarker = options.map?.event?.features?.some(f => {
            const typeName = f.properties?.type?.name ?? f.properties?.type;
            return typeName === 'event';
        }) ?? false;

        const filteredTypes = options.types.filter(t => !hasEventMarker || t.name !== 'event');

        selector.innerHTML = Handlebars.templates['marker-type-selector']({
            types: filteredTypes
        });
    }
});

/**
 * Controle pour dessiner une poly ligne sur un événement
 * avec une sélection du type de poly ligne
 * @param {*} options
 * @returns
 */
const gendlocLineControl = (options) => ({
    ...gendlocMakerControl(options),
    name: 'gendloc_line',
    title: 'Ajouter une ligne',
    className: 'control-icon leaflet-pm-icon-polyline',
});

/**
 * Controle pour dessiner un polygone sur un événement
 * avec une sélection du type de polygone
 * @param {*} options
 * @returns
 */
const gendlocPolygonControl = (options) => ({
    ...gendlocMakerControl(options),
    name: 'gendloc_polygon',
    title: 'Ajouter une zone',
    className: 'control-icon leaflet-pm-icon-polygon',
});

(() => {
    L.quickCoordinateControl = () => new quickCoordinateControl();
    //L.createEventControl = () => new createEventControl();
    L.gendlocMakerControl = (options) => gendlocMakerControl(options);
    L.gendlocLineControl = (options) => gendlocLineControl(options);
    L.gendlocPolygonControl = (options) => gendlocPolygonControl(options);
})();